import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchUserProjects } from '../../../redux/slices/projectsSlice';

const ProjectsCard = () => {
    const { t } = useTranslation(); 
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth?.user);
    const timeBalances = useSelector((state) => state.timeBalances?.items || []);
    
    const userProjects = useSelector((state) => state.projects?.userProjects[user?.id] || []);
    const loading = useSelector((state) => state.projects?.isLoading);

    useEffect(() => {
        if (user?.id) {
            dispatch(fetchUserProjects(user.id));
        }
    }, [dispatch, user?.id]);

    const projectsWithRealData = userProjects.map((project) => {
        let totalMinutesWorked = 0;

        timeBalances.forEach((dayRecord) => {
            if (dayRecord.projects && Array.isArray(dayRecord.projects)) {
                dayRecord.projects.forEach((allocatedProj) => {
                    if (String(allocatedProj.project_id) === String(project.id)) {
                        totalMinutesWorked += allocatedProj.minutes || ((allocatedProj.hours_logged || 0) * 60);
                    }
                });
            }
        });

        const hoursWorked = Math.round((totalMinutesWorked / 60) * 10) / 10; 
        const hoursPlanned = project.estimated_hours || project.planned_hours || 40;
        const percentage = Math.min((hoursWorked / hoursPlanned) * 100, 100);

        return {
            id: project.id,
            name: project.name,
            worked: hoursWorked,
            planned: hoursPlanned,
            color: project.color || 'var(--brand-primary)',
            percentage: percentage
        };
    });

    return (
        <div className="atlar-card d-flex flex-column" style={{ padding: "24px 32px", height: "100%" }}>
            
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="txt-main fw-bold m-0" style={{ fontSize: "1.1rem" }}>
                    {t('components.ProjectsCard.title')}
                </h2>
                <span style={{ fontSize: "0.85rem", color: "var(--gray-400)", cursor: "pointer", fontWeight: "600" }}>
                    {t('components.ProjectsCard.see_all')}
                </span>
            </div>

            <div className="d-flex flex-column custom-scrollbar" style={{ gap: "20px", maxHeight: "280px", overflowY: "auto", paddingRight: "8px" }}>
                {loading ? (
                    <div className="text-muted text-center py-3" style={{ fontSize: "0.9rem" }}>
                        {t('components.ProjectsCard.loading')}
                    </div>
                ) : projectsWithRealData.length === 0 ? (
                    <div className="text-muted text-center py-3" style={{ fontSize: "0.9rem" }}>
                        {t('components.ProjectsCard.no_projects')}
                    </div>
                ) : (
                    projectsWithRealData.map(project => (
                        <div key={project.id}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="txt-main fw-bold" style={{ fontSize: "0.95rem" }}>{project.name}</span>
                                <span style={{ fontSize: "0.85rem", color: "var(--gray-400)", fontWeight: "600" }}>
                                    {project.worked}h / {project.planned}h
                                </span>
                            </div>
                            
                            <div className="w-100 rounded-pill overflow-hidden" style={{ height: "6px", backgroundColor: "var(--gray-200)" }}>
                                <div 
                                    style={{
                                        height: "100%",
                                        width: `${project.percentage}%`,
                                        backgroundColor: project.color,
                                        borderRadius: "10px",
                                        transition: "width 0.4s ease-in-out"
                                    }}
                                />
                            </div>
                        </div>
                    ))
                )}
            </div>
            
        </div>
    );
};

export default ProjectsCard;